import { FC, PropsWithChildren } from 'react';
import './TransactionsDateFilterDialogFromGroup.scss';

export const TransactionsDateFilterDialogFromGroup: FC<PropsWithChildren> = ({ children }) => {
  return <div className="TransactionsDateFilterDialogFromGroup">{children}</div>;
};
